import React, { useState, useEffect } from 'react';
import './LegalModal.css';

function LegalModal({ isOpen, initialTab = 'privacy', onClose }) {
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    if (isOpen) {
      setActiveTab(initialTab);
    }
  }, [isOpen, initialTab]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-card legal-modal-card">
        <div className="legal-modal-header">
          <div className="legal-tabs">
            <button
              type="button"
              className={`legal-tab-btn ${activeTab === 'privacy' ? 'active' : ''}`}
              onClick={() => setActiveTab('privacy')}
            >
              Privacy Policy
            </button>
            <button
              type="button"
              className={`legal-tab-btn ${activeTab === 'terms' ? 'active' : ''}`}
              onClick={() => setActiveTab('terms')}
            >
              Terms of Service
            </button>
          </div>
        </div>

        <div className="legal-modal-body">
          {activeTab === 'privacy' ? (
            <div>
              <h2>Privacy Policy</h2>
              <p className="legal-meta">Last updated: September 2026</p>

              <p>
                <strong>AnicaTheCoach</strong> processes minimal personal data strictly necessary to deliver and manage your fitness training.
              </p>

              <h3>1. Data We Collect</h3>
              <ul>
                <li><strong>Account details:</strong> Name, email, optional phone &amp; birth date, encrypted password.</li>
                <li><strong>Training data:</strong> Assigned workouts, completion status, and optional notes/comments (including any physical limitations or injuries you voluntarily share).</li>
              </ul>

              <h3>2. Purpose &amp; Security</h3>
              <ul>
                <li><strong>Use of data:</strong> Exclusively used by your coach to create, adapt, and schedule your training.</li>
                <li><strong>Encryption &amp; Privacy:</strong> Passwords are cryptographic hashes. Contact details (phone, birth date) and workout comments/notes are strongly encrypted at rest. We never sell, share, or monetize your information.</li>
              </ul>

              <h3>3. Your GDPR Rights &amp; Data Deletion</h3>
              <ul>
                <li><strong>Access &amp; Rectification:</strong> You can view your training history anytime in the app. For profile updates, contact your coach.</li>
                <li><strong>Erasure (Right to be Forgotten):</strong> You may request complete deletion of your account and all workout records at any time.</li>
                <li><strong>Contact:</strong> Email <a href="mailto:pantovic.online@gmail.com">pantovic.online@gmail.com</a> with the subject <em>&quot;Data Deletion Request&quot;</em>. All data is deleted within 30 days.</li>
              </ul>
            </div>
          ) : (
            <div>
              <h2>Terms of Service</h2>
              <p className="legal-meta">Last updated: September 2026</p>

              <p>
                By using <strong>AnicaTheCoach</strong>, you agree to these Terms and our Privacy Policy.
              </p>

              <h3>1. Fitness &amp; Health Disclaimer</h3>
              <ul>
                <li><strong>Not Medical Advice:</strong> Workouts and advice provided are for fitness purposes only and do not replace professional medical guidance.</li>
                <li><strong>Assumption of Risk:</strong> You confirm that you are physically capable of performing the exercises. Always notify your coach of any injuries or health concerns.</li>
              </ul>

              <h3>2. Account &amp; Conduct</h3>
              <ul>
                <li>Keep your login credentials secure and do not share your account.</li>
                <li>Use comments respectfully for training and feedback purposes only.</li>
              </ul>

              <h3>3. Video Content &amp; Intellectual Property</h3>
              <ul>
                <li><strong>Proprietary Videos:</strong> Private exercise demonstrations (e.g., coach's unlisted YouTube videos) are strictly for your personal use within the app. Copying, recording, or sharing these links externally is prohibited.</li>
                <li><strong>Third-Party Media:</strong> External video links remain the property of their respective owners and are subject to their original platform terms.</li>
              </ul>

              <h3>4. Account Closure</h3>
              <p>
                You may close your account at any time by contacting: <a href="mailto:pantovic.online@gmail.com">pantovic.online@gmail.com</a>
              </p>
            </div>
          )}
        </div>

        <div className="legal-modal-footer">
          <button type="button" className="button button-primary legal-close-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default LegalModal;
